<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-card flat>
          <v-card-title> Media Komunikasi </v-card-title>
          <v-data-table :headers="headers" :items="items" dense>
            <template v-slot:[`item.date`]="{ item }">
              {{
                item.date
                  ? $moment(item.date).format("DD MMMM YYYY | HH:mm:ss")
                  : null
              }}
            </template>
            <template v-slot:[`item.notes`]="{ item }">
              <span v-html="item.notes"></span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    items: null,
  },
  data() {
    return {
      headers: [
        {
          text: "Tanggal",
          sortable: true,
          value: "date",
        },
        {
          text: "Media",
          sortable: true,
          value: "media",
        },
        {
          text: "Kepada/Tertuju",
          sortable: true,
          value: "by",
        },
        {
          text: "Keterangan",
          sortable: true,
          value: "notes",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style>
</style>